import { brandCategories, brandTrademarkDisclaimer, brands } from "@/config/brands";
import { useI18n } from "@/i18n";
import { getMarketingCopy } from "@/i18n/marketing-copy";

export function AboutBrands() {
  const { locale } = useI18n();
  const copy = getMarketingCopy(locale)?.about.brands;
  return (
    <section id="brands" className="section-y border-t border-border bg-muted/40">
      <div className="container-page">
        <p className="eyebrow">{copy?.eyebrow ?? "Materials"}</p>
        <h2 className="display-2 mt-3 max-w-3xl text-balance">
          {copy?.title ?? "Roofing materials we trust"}
        </h2>
        <p className="mt-4 max-w-3xl text-[1.02rem] leading-relaxed text-muted-foreground">
          {copy?.body ??
            "Product selection follows the roof assembly, slope, exposure and architecture - not a single default brand. The manufacturers below are systems Revolin Roofing installs when they fit the project."}
        </p>

        <div className="mt-12 space-y-12">
          {brandCategories.map((category) => {
            const categoryBrands = brands.filter((brand) => brand.category === category.id);
            if (!categoryBrands.length) return null;
            return (
              <div key={category.id}>
                <h3 className="text-xl font-semibold">
                  {copy?.categories[category.id]?.title ?? category.title}
                </h3>
                <p className="mt-3 max-w-3xl text-sm leading-7 text-muted-foreground">
                  {copy?.categories[category.id]?.body ?? category.body}
                </p>
                {/* Text badges — optional logoSrc supported later after permission. */}
                <ul className="mt-6 flex flex-wrap gap-3">
                  {categoryBrands.map((brand) => (
                    <li key={brand.id}>
                      <span className="inline-flex items-center gap-2 rounded-md border border-border bg-card px-4 py-2 text-sm font-medium tracking-tight text-foreground">
                        {brand.name}
                        {brand.bcMade ? (
                          <span className="text-[0.65rem] font-semibold tracking-[0.12em] text-accent uppercase">
                            {copy?.bcMade ?? "BC-Made"}
                          </span>
                        ) : null}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <p className="mt-12 max-w-3xl text-xs leading-6 text-muted-foreground">
          {copy?.disclaimer ?? brandTrademarkDisclaimer}
        </p>
      </div>
    </section>
  );
}
